import type { GetStaticProps, InferGetStaticPropsType } from "next";

import { ArchiveSeo, indexCopy } from "@/components/blog/ArchiveSeo";
import { BlogArchive } from "@/components/blog/BlogArchive";
import Footer from "@/components/shared/Footer";
import { blogPagePath } from "@/lib/blog/paths";
import { useClientFallback } from "@/lib/blog/useClientFallback";
import { getPostPage, type PostPage } from "@/lib/ghost";

export const getStaticProps = (async () => {
  const page = await getPostPage(1);

  return {
    props: { page },
    revalidate: 3600,
  };
}) satisfies GetStaticProps<{ page: PostPage | null }>;

export default function BlogIndexPage({ page }: InferGetStaticPropsType<typeof getStaticProps>) {
  const { data, loading } = useClientFallback(page, "blog:1", () => getPostPage(1));
  const copy = indexCopy(1, data?.pages ?? 1);

  return (
    <>
      <ArchiveSeo copy={copy} path={blogPagePath(1)} posts={data?.posts ?? []} breadcrumbs={[]} />
      <BlogArchive
        page={data}
        loading={loading}
        heading={copy.heading}
        intro={copy.intro}
        pathFor={blogPagePath}
        topics
      />
      <Footer />
    </>
  );
}
